document.addEventListener('DOMContentLoaded', function() {

  function handleATagClick(event) {
    event.preventDefault();
    let link = event.currentTarget;
    let currentWbox = link.nextElementSibling;

  }



  function handleIIconClick(event) {
    event.stopPropagation(); 
    event.preventDefault();
    let icon = event.currentTarget;
    let parentA = icon.parentElement;
    let parentItem = parentA.parentElement;
    let subMenu = parentItem.querySelector('ul');

 
    let allItems = parentItem.parentElement.children;
    let computedMarginTop = getComputedStyle(subMenu).marginTop;

    for (let item of allItems) {
      if (item !== parentItem) {
        let subMenu = item.querySelector('ul');
        if (subMenu) {
          // subMenu.style.display = 'none';
          // subMenu.style.marginTop= '-10000%';
          subMenu.classList.remove('subon');
        }
        item.classList.remove('cur', 'cur2', 'cur3');
      }
    }


    if (subMenu) {
      // subMenu.style.display = subMenu.style.display === 'block' ? 'none' : 'block';
      // subMenu.style.marginTop = computedMarginTop === '0px' ? '-10000%' : '0';
      subMenu.classList.toggle('subon');
    }
 const specialDiv = document.querySelector('.zlk-wbox.dqxqy-zlk-wbox');

    if (parentItem.classList.contains('item')) {  
        parentItem.classList.toggle('cur');  
    } else if (parentItem.parentElement.classList.contains('sub')) {  
        let grandParentItem = parentItem.parentElement.parentElement;  
        if (grandParentItem.tagName === 'LI' && grandParentItem.parentElement.classList.contains('sub')) {  
            parentItem.classList.toggle('cur3');  
            // grandParentItem.parentElement.classList.toggle('cur2');  
        } else {  
            parentItem.classList.toggle('cur2');  
        } 
    } 
  }


  document.querySelectorAll('.categray > div.item > a.dja').forEach(function(link) {
    link.addEventListener('click', handleATagClick);
    let snDown = link.querySelector('i.sn-down');
    if (snDown) {
      snDown.addEventListener('click', handleIIconClick);
    }
  });


  document.querySelectorAll('.categray > div.item ul.sub > li > a.dja').forEach(function(link) {
    link.addEventListener('click', handleATagClick);
    let snDown = link.querySelector('i.sn-down');
    if (snDown) {
      snDown.addEventListener('click', handleIIconClick);
    }
  });


  document.querySelectorAll('.categray > div.item ul.sub > li ul.sub > li > a.dja').forEach(function(link) {
    link.addEventListener('click', handleATagClick);
    let snDown = link.querySelector('i.sn-down');
    if (snDown) {
      snDown.addEventListener('click', handleIIconClick);
    }
  });













document.querySelectorAll('.categray a.dja').forEach(function(link) {
  link.addEventListener('click', function(event) {
    event.preventDefault();

    let parentItem = link.parentElement;
    let currentWbox = parentItem.querySelector('.zlk-wbox');


    document.querySelectorAll('.zlk-wbox').forEach(function(wbox) {
      wbox.classList.remove('zlk-wbox-active');
      wbox.style.display = 'none';
    });


    if (currentWbox) {
      currentWbox.style.display = 'block';
      currentWbox.style.height = 'auto';


      currentWbox.classList.add('zlk-wbox-active');


      updateCollectionHeight(currentWbox.offsetHeight);
    }

    document.querySelectorAll('.categray a.dja').forEach(function(otherLink) {
      otherLink.classList.remove('djabh');
    });

    link.classList.add('djabh');


    document.querySelectorAll('.zlk-wbox').forEach(function(otherWbox) {
      if (otherWbox !== currentWbox) {
        otherWbox.classList.remove('zlk-wbox-active');
      }
    });
  });
});


function updateCollectionHeight(height) {
  const customCollectionProducts = document.querySelector('.custom-collection-products');
  if (customCollectionProducts) {
    customCollectionProducts.style.height = `${height}px`;
  }
}









  



  

  const sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      const selectedOption = this.value;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', selectedOption);
      window.location.href = url.toString();
    });
  }
});















          const toggleButton = document.querySelector('.lxtype-t');
            const cfjt = document.querySelector('.cfjt');
            const xlbox = document.querySelector('.lxtype-box');

            toggleButton.addEventListener('click', () => {
                cfjt.classList.toggle('active');
                xlbox.classList.toggle('active');
            });









document.addEventListener("DOMContentLoaded", function() {
    function checkAndToggleDisplay() {
        const activeContainer = document.querySelector('.zlk-wbox-active>.lxtype-contant-wrap>.lxtype-contant');
        if (!activeContainer) {
            console.log("Active container not found");
            return;
        }

        const wjLists = activeContainer.querySelectorAll('.wj-list');
        const myWjList = activeContainer.querySelector('.mywj-list');
        
        let allHidden = true;
        if (wjLists.length === 0 || !myWjList) {
            allHidden = true;
        } else {
            wjLists.forEach(wjList => {
                const display = window.getComputedStyle(wjList).display;
                if (display !== 'none') {
                    allHidden = false;
                }
            });
        }

        if (allHidden) {
            console.log("Setting .mywj-list to display: block");
            if (myWjList) {
                myWjList.style.display = 'block';
            } else {
                const newMyWjList = document.createElement('div');
                newMyWjList.className = 'mywj-list';
                newMyWjList.style.display = 'block';
                activeContainer.appendChild(newMyWjList);
            }
        } else if (myWjList) {
            console.log("Setting .mywj-list to display: none");
            myWjList.style.display = 'none';
        }
    }


    checkAndToggleDisplay();


    const observer = new MutationObserver(checkAndToggleDisplay);
    document.querySelectorAll('.wj-list').forEach(wjList => {
        observer.observe(wjList, { attributes: true, attributeFilter: ['style', 'class'] });
    });

    // For demonstration, adding a manual trigger to test changes
    document.querySelector('.test-button').addEventListener('click', checkAndToggleDisplay);
});














    document.addEventListener('DOMContentLoaded', function() {
        const sliders = document.querySelectorAll('.slider');
        
        sliders.forEach(function(slider) {
            const foregroundImg = slider.parentElement.querySelector('.foreground-img');
            const sliderButton = slider.parentElement.querySelector('.slider-button');
            
            slider.addEventListener('input', function() {
                const sliderPos = slider.value;
                foregroundImg.style.width = `${sliderPos}%`;
                sliderButton.style.left = `calc(${sliderPos}% - 18px)`;
            });
        });
    });

function openTab(tabName) {
    var i, tabContent, tabButton;

    // Hide all tab content
    tabContent = document.getElementsByClassName("tab-content");
    for (i = 0; i < tabContent.length; i++) {
        tabContent[i].style.display = "none";
    }

    // Remove 'active' class from all tab buttons
    tabButton = document.getElementsByClassName("tab-button");
    for (i = 0; i < tabButton.length; i++) {
        tabButton[i].classList.remove("active");
    }

    // Show the specific tab content
    document.getElementById(tabName).style.display = "block";

    // Add 'active' class to the clicked tab button
    event.currentTarget.classList.add("active");

   // 每次点击时重新获取 .cpxxq-box 元素并置顶到页面顶部
    var elementsToScroll = document.querySelectorAll('.cpxxq-box'); // 获取所有需要置顶的元素
    elementsToScroll.forEach(function(element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });


  
  // Show the specific tab content and add active class
    var activeTabContent = document.getElementById(tabName);
    activeTabContent.style.display = "block";
    activeTabContent.classList.add("active");
  // Add active class to the clicked tab button
    event.currentTarget.classList.add("active");
    // 滚动到当前激活的 tab-content 的顶部
    if (activeTabContent) {
        var rect = activeTabContent.getBoundingClientRect();
        var offset = 100; // Adjust this value according to the height of your fixed header/menu
        var scrollTop = rect.top + window.pageYOffset - offset;

        window.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
        });
    }
  // 更新 body 背景色
    if (tabName === 'tab3') { // 'tab3' 对应于 "OPTIONS"
        document.body.style.background = '#fff';
       document.body.style.overflowX = 'hidden';  
    } else {
        document.body.style.background = 'unset';
    }

}












// banner
document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('.bannerbox');

    carousels.forEach(carousel => {
        const slides = carousel.querySelectorAll('.carousel-item');
        const dots = carousel.querySelectorAll('.slider-counter__link');
        let currentIndex = 0;

        function showSlide(newIndex, direction) {
            slides.forEach((slide, i) => {
                slide.classList.remove('active', 'slide-left', 'slide-right');
                if (i === newIndex) {
                    slide.classList.add('active', direction === 'right' ? 'slide-right' : 'slide-left');
                }
            });
            dots.forEach((dot, i) => {
                dot.classList.toggle('slider-counter__link--active', i === newIndex);
            });
        }

        function prevSlide() {
            const direction = 'left';
            currentIndex = (currentIndex === 0) ? slides.length - 1 : currentIndex - 1;
            showSlide(currentIndex, direction);
        }

        function nextSlide() {
            const direction = 'right';
            currentIndex = (currentIndex === slides.length - 1) ? 0 : currentIndex + 1;
            showSlide(currentIndex, direction);
        }

        function currentSlide(index) {
            const direction = index > currentIndex ? 'right' : 'left';
            currentIndex = index;
            showSlide(currentIndex, direction);
        }

        // Show the first slide initially
        showSlide(currentIndex, 'right');

        // Assign functions to control buttons
        carousel.querySelector('.carousel-control-prev').addEventListener('click', prevSlide);
        carousel.querySelector('.carousel-control-next').addEventListener('click', nextSlide);

        dots.forEach((dot, index) => {
            dot.addEventListener('click', function() {
                currentSlide(index);
            });
        });
    });
});


